import { getLocalizedField } from './get-localized-field';
import { BookingLocationType } from '@/entities/bookings/booking-location-type.enum';
import type { Allocation } from '@/entities/allocations/allocation.entity';

export const getLocationText = (
  item: Pick<
    Allocation,
    | 'pickupLocationType'
    | 'pickupLocationGeocodedAddress'
    | 'pickupResponsibleStation'
    | 'dropoffLocationType'
    | 'dropoffLocationGeocodedAddress'
    | 'dropoffResponsibleStation'
  >,
  mode: 'pickup' | 'dropoff',
  language: string | undefined,
) => {
  if (item[`${mode}LocationType`] === BookingLocationType.STATION) {
    // Place is the geocoded handover station; the responsible station is the hub.
    const placeName = item[`${mode}LocationGeocodedAddress`]?.displayName;
    if (placeName) return placeName;
    const stationInfo = item[`${mode}ResponsibleStation`]?.info;
    return stationInfo ? getLocalizedField(stationInfo, language) : '';
  }
  return item[`${mode}LocationGeocodedAddress`]?.displayName;
};
